export const HolidayRSVPAnswer = {
    Attending: 1,
    NotAttending: 2,
};
